export default __webpack_public_path__ + "static/media/mic.06be56ec.svg";